import Axios from "axios";
import { handleError } from "../../utils/utils";

export async function getShippingCost() {
  try {
    const shippingCost = await Axios.get(`/v2/cart/shipping-cost`);

    if (!shippingCost) throw Error("No se encontró el costo de envío");

    return shippingCost.data;
  } catch (error) {
    handleError(error);
  }
}

export async function getShippingCostByCompanyName(
  companyName: string,
  carrierName?: string
) {
  try {
    companyName = companyName.replace(/-/g, " ");

    const url = `/v2/cart/shipping-cost/${companyName}`;
    const params = carrierName && carrierName.trim() ? { carrierName } : {};

    const shippingCost = await Axios.get(url, { params });

    if (!shippingCost) throw Error("No se encontró el costo de envío");

    return shippingCost.data;
  } catch (error) {
    handleError(error);
  }
}

export async function getShippingCarriers() {
  try {
    const carriers = await Axios.get(`/v2/cart/shipping-carriers`);

    if (!carriers) throw Error("No se encontraron empresas transportadoras");

    return carriers.data;
  } catch (error) {
    handleError(error);
  }
}
